// extracted by mini-css-extract-plugin
module.exports = {"toast":"toastWarning_toast__xtejQ","iconBlock":"toastWarning_iconBlock__Xyz-q"};